import React, {useEffect} from 'react'

import {Box, Container, Grid} from '@mui/material'
import JumboTitle from 'components/JumboTitle'

import PageLoader from '@progyny/components/PageLoader'
import {pageTestIds} from '@progyny/const/pageTestIds'
import {useConsultationPage} from '@progyny/hooks/useConsultationPage'
import {useMeStore} from '@progyny/store/meStore'

interface ConsultationPageLayoutProps {
  consultationSlug: string
  children: (
    consultation: any,
    colors: any,
    theme: any,
    refetchConsultationDetail: (variables?: unknown) => Promise<unknown>
  ) => React.ReactNode
  titleOverride?: string | null
  descriptionOverride?: string | null
}

const ConsultationPageLayout: React.FC<ConsultationPageLayoutProps> = ({
  consultationSlug,
  children,
  titleOverride,
  descriptionOverride,
}) => {
  const user = useMeStore((s) => s.user)
  const isLanguageChanged =
    user?.member?.language !== localStorage.getItem('ui_language')
  const {
    consultation,
    colors,
    theme,
    loading,
    error,
    refetch: refetchConsultationDetail,
  } = useConsultationPage(consultationSlug)

  useEffect(() => {
    if (isLanguageChanged) {
      refetchConsultationDetail()
    }
  }, [isLanguageChanged, refetchConsultationDetail])

  if (loading || error) {
    return (
      <Box minHeight={140} data-testid={pageTestIds.consultations}>
        <PageLoader position={'center'} />
      </Box>
    )
  }

  return (
    <Container maxWidth={'xl'} data-testid={pageTestIds.consultations}>
      <JumboTitle
        title={titleOverride ?? consultation.title}
        description={descriptionOverride ?? consultation.description}
      >
        <Grid container data-testid='consultations-content'>
          {children(consultation, colors, theme, refetchConsultationDetail)}
        </Grid>
      </JumboTitle>
    </Container>
  )
}

export default ConsultationPageLayout
